import { createSlice } from "@reduxjs/toolkit";
import { current } from "@reduxjs/toolkit";

const initialState = {
  details: {},
  requestToDeliveryDate: false,
  responseFromDeliveryDate: false,
  failedToDeliveryDate: false,
  error: null,
  isDateLoaded: false,
};

export const DeliveryDateSlice = createSlice({
  name: "DeliveryDates",
  initialState,
  reducers: {
    requestToFetchDeliveryDateAction: (state) => {
      return {
        ...state,
        requestToDeliveryDate: true,
      };
    },
    requestToFetchInitialPlpServiceabilityAction: (state) => {
      return {
        ...state,
        requestToDeliveryDate: true,
      };
    },
    responseFromFetchDeliveryDateAction: (state, action) => {
      return {
        ...state,
        responseFromDeliveryDate: true,
        details: {
          ...action.payload,
          deliveryDates: { ...(current(state?.details)?.deliveryDates || {}), ...action.payload.deliveryDates },
        },
      };
    },
    failedToFetchDeliveryDateAction: (state, action) => {
      return {
        ...state,
        failedToDeliveryDate: true,
        error: action.payload,
      };
    },
    clearDeliveryDatesAction: () => {
      return initialState;
    },
    setIsDateLoaded: (state, action) => {
      return {
        ...state,
        isDateLoaded: action.payload,
      };
    },
  },
});

export default DeliveryDateSlice.reducer;
export const {
  failedToFetchDeliveryDateAction,
  requestToFetchDeliveryDateAction,
  requestToFetchInitialPlpServiceabilityAction,
  responseFromFetchDeliveryDateAction,
  clearDeliveryDatesAction,
  setIsDateLoaded,
} = DeliveryDateSlice.actions;
